// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewBankDetails_scrollable-content__ZJCnu","card":"ViewBankDetails_card__8Jpce","ant-card-head-title":"ViewBankDetails_ant-card-head-title__AAcT2"};